import {
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  message,
  Select,
  Image,
  Typography,
} from "antd";
import md5 from "md5";
import User from "models/user/user";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import RecoveryPassword from "assets/images/recovery-password.png";

import {
  deleteQueryParam,
  redirectToUrl,
  setFieldErrorsFromServer,
} from "utilities/generalUtility";
import Logo from "assets/images/logo.svg";
import LogoBackground from "assets/images/diary-bg-img.jpg";
import ArrowImage from "assets/images/arrow-img.svg";
import { passwordMessage, passwordRegex } from "utilities/regexUtilities";

export default function SetPassword() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [form] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false);
  // const paramJson = qs.parse(location.search, { ignoreQueryPrefix: true });
  const queryParams = new URLSearchParams(window.location.search);
  let token = decodeURIComponent(queryParams.toString().split("=")[1]);
  token = token.split("&")[0];
  const email = queryParams.get("email");

  useEffect(() => {
    if (queryParams.err) {
      message.error(queryParams.err);
      deleteQueryParam("err");
    }
  }, []);

  const onFinish = async (values) => {
    // const encryptedPass = md5(values.password);
    if (values.password !== values.confirmPassword) {
      message.error("Password does not match!");
      return;
    }
    delete values["confirmPassword"];
    values = { ...values, token, email };
    try {
      setBtnLoading(true);

      const res = await dispatch(User.resetPassword(values));
      // message.success(res?.message);
      setBtnLoading(false);
      User.getPortalUser() ? redirectToUrl("/") : User.logoutCall();
    } catch (error) {
      setBtnLoading(false);
      message.error(error?.message);
      setFieldErrorsFromServer(error, form, values);
    }
  };
  const { Title } = Typography;

  return (
    <React.Fragment>
      <div className="login-container d-flex">
        {/* <div className="logo-wrapper text-center">
          <img className="logo" src={Logo} alt="" />
          <img className="arrow-img" src={ArrowImage} alt="" />
        </div> */}
        <div className="login-bg w-100">
          <img className="login-img w-100 h-100" src={LogoBackground} alt="" />
        </div>
        <Card bordered={false} className="login-card">
          <div className="authentication-logo text-center">
            <img className="logo" src={Logo} alt="" />
          </div>
          <Title level={4}>Set Password</Title>
          <Form
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            layout="vertical"
          >
            {/* <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your Email!",
                },
              ]}
            >
              <Input
                type="email"
                suffix={<i className="icon-email site-form-item-icon"></i>}
                placeholder="email"
                size="large"
              />
            </Form.Item> */}
            <Form.Item
              name="password"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },

                {
                  whitespace: true,
                  message: "All spaces are not allowed",
                },
                {
                  pattern: new RegExp(passwordRegex),
                  message: passwordMessage,
                },
              ]}
            >
              <Input.Password
                placeholder="password"
                size="large"
                autoComplete="false"
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input your confirm password!",
                },
                {
                  whitespace: true,
                  message: "All spaces are not allowed",
                },
                {
                  pattern: new RegExp(passwordRegex),
                  message: passwordMessage,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match"
                      )
                    );
                  },
                }),
              ]}
              className="mb-0"
            >
              <Input.Password
                placeholder="confirm password"
                size="large"
                autoComplete="false"
              />
            </Form.Item>
            <Form.Item className="my-4">
              <Button
                block
                size="large"
                type="primary"
                htmlType="submit"
                loading={btnLoading}
              >
                Continue
              </Button>
            </Form.Item>
            <Title level={5} className="text-center">
              Remember your password?
              <Link to="/login">Login</Link>
            </Title>
          </Form>
        </Card>
      </div>
    </React.Fragment>
  );
}
